// Tuile du produit, remplie de la couleur du statut (PER-2447 : la couleur
// dominante du statut doit rester bien visible sur la carte). Avec `code`, la
// tuile affiche aussi le code court du produit (AC, MRP, DOMI…).
const ProduitLead = ({ icone = "fa-car", libelle = "Produit", code = "", petit = false }) => (
  <span
    className={["la-produit", petit ? "la-produit--petit" : "", code ? "la-produit--code" : ""].filter(Boolean).join(" ")}
    title={libelle}
  >
    <i className={`fa ${icone}`} aria-hidden="true" />
    {code && (
      <span className="la-produit__code" aria-hidden="true">
        {code}
      </span>
    )}
    <span className="sr-only">{libelle}</span>
  </span>
);

export default ProduitLead;
